import { render, staticRenderFns } from "./FAddField.vue?vue&type=template&id=52cf4652&scoped=true"
import script from "./FAddField.vue?vue&type=script&lang=js"
export * from "./FAddField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf4652",
  null
  
)

export default component.exports